import { z } from "zod";

export const PaginatedSchema = <T extends z.ZodTypeAny>(object: T) =>
  z.object({
    data: z.array(object),
    links: z.object({
        first: z.string().nullable(),
        last:  z.string().nullable(),
        prev: z.string().nullable().optional(),
        next: z.string().nullable().optional(),
    }),
    meta: z.object({
        path:        z.string(),
        per_page:    z.number(),
        next_cursor: z.string().nullable(),
        prev_cursor: z.string().nullable(),
    }),
  });  

export const DEFAULT_BROWSE_PER_PAGE = 10;

export type PaginatedResponse<T> = {
  data: T[];
  links: {
    first: string | null;
    last: string | null;
    prev?: string | null;
    next?: string | null;
  };
  meta: PaginatedMeta;
};

export type PaginatedMeta = {
  path: string;
  per_page: number;
  next_cursor: string | null;
  prev_cursor: string | null;
};